export default {
  data() {
    return {
      allSelectedVehicleTypes: [],
    };
  },
  methods: {
    getAllDrugVehicleType: function (drugId) {
      const params = {
        drugId,
      };
      this.load.val = true;
      this.$store
        .dispatch('getAllDrugVehicleTypesDispatch', params)
        .then(() => {
          if (this.$store.state.drugVehicleTypeModule.successFlag) {
            const data = this.$store.state.drugVehicleTypeModule.allDrugVehicleTypes;
            this.allSelectedVehicleTypes = [...data].map((item) => item?.vehicleType);
          } else {
            if (this.$store.state.chiefComplaintModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.this.getAllAttchments(this.chiefComplaintId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.drugVehicleTypeModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.this.getAllAttchments(this.chiefComplaintId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    addRangeOfAttachments: function () {
      const body = {
        drugId: this.selectedDrugId,
        vehicleTypeIds: [...this.allSelectedVehicleTypes].map(({ id }) => id),
      };
      this.load.val = true;
      this.$store
        .dispatch('setRangeOfDrugVehicleTypeDispatch', body)
        .then(() => {
          if (this.$store.state.drugVehicleTypeModule.successFlag) {
            this.showSuccessAlert('وسایل نقیله مورد نظر به دارو تخصیص داده شد.');
            this.closeDrugVehicleTypeModal();
          } else {
            if (this.$store.state.drugVehicleTypeModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.this.addRangeOfAttachments();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.drugVehicleTypeModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.this.addRangeOfAttachments();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
  },
};
